
import { ElementType, useContext } from 'react';
import {
	Stack
} from '@mui/material';
import { ConversationContext } from '@my-helpers/common';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import {
	ConversationsList,
	DeleteConversation,
	ConversationsHeader
} from '@/components/conversation';
import { Notification } from '@/components/Notification';
import { ConversationView } from './conversation';

export const ConversationsView: ElementType = () => {
	const ctx = useContext(ConversationContext);
	if (!ctx) {
		throw new Error('ConversationsView must be used within a ConversationProvider');
	}
	const { conversations } = ctx.view;
	const { deleteConversation, clearError } = ctx.command;
	const theme = useTheme();
	const [starting, setStarting] = useState(false);
	const [deleting, setDeleting] = useState<string | null>(null);
	const { isLoading, error } = ctx.view;

	if (starting) {
		return (
			<ConversationView />
		)
	}

	return (
		<Stack padding={theme.spacing(3)}>
			<ConversationsHeader 
				setStarting={setStarting} />
			{conversations && (
				<ConversationsList 
					conversations={conversations}
					deleteConversation={deleteConversation}
				/>
			)}

			{deleting && (
				<DeleteConversation
					deleteConversation={deleteConversation}
					deleting={deleting}
					setDeleting={setDeleting}
				/>
			)}
			<Notification
				isLoading={isLoading}
				clearError={clearError}
				error={error}
				delay={300}
				autoHideDuration={1200}
			/>
		</Stack>
	)
}

